import {
  OvlAddComponent,
  OvlAddDialog,
  OvlAddScreen,
} from "../../../../../../_ovlclient/src/global/globals"
import { ScreenOfferingDetails } from "../../screens/qutoffering/offering/details/offeringdetails"
import { ScreenOffering } from "../../screens/qutoffering/offering/offering"
import { ScreenOfferingAdmin } from "../../screens/qutoffering/offering/offeringadmin"
import { ScreenOfferingAdminCut } from "../../screens/qutoffering/offering/offeringadmincut"
import { CompDialogQUTOfferingPos } from "./offering/cut/poslist/poslist"
import { CompOfferingSettings } from "./offeringsettings/offeringsettings"

export const QUTOffering_Init = () => {
  OvlAddComponent("comp-offeringsettings", CompOfferingSettings)
  OvlAddDialog(CompDialogQUTOfferingPos, "QUTOfferingPos")
  OvlAddScreen(ScreenOffering, "QUTOffering")
  OvlAddScreen(ScreenOfferingAdmin, "QUTOfferingAdmin")
  OvlAddScreen(ScreenOfferingAdminCut, "QUTOfferingAdminCut")
  OvlAddScreen(ScreenOfferingDetails, "QUTOfferingDetails")
}
